import { UploadService } from './../../core/services/upload.service';
import { NgForm } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseService } from 'src/app/core/services/base.service';
// import { TeacherCourse } from '../../core/models/teacherCourse';
import { DatePipe } from '@angular/common';

import { Course } from '../../core/models/course';
import { Category } from '../../core/models/category';
import { CourseService } from 'src/app/core/services/course.service';

@Component({
  selector: 'app-create-course',
  templateUrl: './create-course.component.html',
  styleUrls: ['./create-course.component.scss']
})
export class CreateCourseComponent extends BaseComponent implements OnInit {
  @ViewChild('CourseForm', { static: false }) CourseForm: NgForm;
  teacherId: number;
  tokenValid: boolean;

  course = {} as Course;
  categories: Category[];
  courseIdString: string;

  file: File = null;
  pdfFile: File | undefined;
  pdfLink: boolean = false;

  timeTableFile: File | undefined;
  timeTableLink: boolean = false;


  createEditBtn: boolean = false;
  myDate = new Date();
  courseType: string = 'freeCourse';
  academyToken: string;
  loading = false;

  freeTab: boolean = true;

  constructor(
    public baseService:BaseService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private upload: UploadService,
    private courseService: CourseService,
    public datepipe: DatePipe,
  ) { super() }

  ngOnInit(): void {
    var teachId = localStorage.getItem('teacherId');
    this.teacherId = Number(teachId);

    const token = localStorage.getItem('token');
    this.academyToken = localStorage.getItem('academyToken');
    if (token) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    this.loadData();
    // console.log(this.myDate);
  }

  loadData(){
    debugger
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data=>{
        this.categories = data.categories.result.returnData;
        // console.log(this.categories)
        this.route.params.subscribe(params => {
          if (params.type === 'add') {
            this.createEditBtn = false;
          }
          else if (params.type === 'edit') {
            debugger
            this.course = data.course.result.returnData;
            this.course.sDate = new Date(this.course.startDate);
            this.course.eDate = new Date(this.course.endDate);
            // console.log(this.course);

            this.createEditBtn = true;

            if (this.course.price === 0 && this.course.offerPrice === 0) {
              this.freeTab = true;
            }
            else if (this.course.price !== 0) {
              this.freeTab = false
            }
          }
        });
      });
  }

  courseThumbnail(event) {
    this.file = event.target.files[0];
    this.upload.upload(this.file).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      this.course.thumbNail = data.result.filePath;
      // console.log(this.baseService.appUrl+ this.course.thumbNail);
    })
  }

  coursePDF(event: any) {
    this.pdfFile = event.target.files[0];
    this.upload.upload(this.pdfFile).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      this.course.pdfLink = data.result.filePath;
      this.pdfLink = true;
    })
  }

  showPdf() {
    window.open(this.baseService.appUrl + this.course.pdfLink, '_blank')
  }

  courseTimeTable(event: any) {
    this.timeTableFile = event.target.files[0];
    this.upload.upload(this.timeTableFile).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      this.course.timeTableLink = data.result.filePath;
      this.timeTableLink = true;
    })
  }

  showTimeTable() {
    window.open(this.baseService.appUrl + this.course.timeTableLink, '_blank')
  }

  FreeCourse() {
    this.course.price = 0;
    this.courseType = 'freeCourse';
  }

  PricedCourse() {
    this.courseType = 'pricedCourse';
  }

  createCourse() {
    debugger
    this.loading = true;
    let s_date = this.datepipe.transform(this.course.sDate, 'yyyy-MM-dd'); 
    let e_date = this.datepipe.transform(this.course.eDate, 'yyyy-MM-dd'); 
    this.course.startDate = s_date;
    this.course.endDate = e_date;

    if (this.courseType === 'freeCourse') {
      if (this.course.studentsNo === 0) {
        this.alertService.error(this.translate.instant('studentsCantBeZero'))
      }
      else if (this.course.duration === 0) {
        this.alertService.error(this.translate.instant('hoursCantBeZero'))
      }
      else if (this.course.lessons === 0) {
        this.alertService.error(this.translate.instant('lessonsCantBeZero'))
      }
      else {
        debugger
        this.course.academyToken = this.academyToken;
        this.course.teacherId = this.teacherId;

        this.baseService.blockStart();
        this.courseService.save(this.course).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
          (data: any) => {
            if (data.result.message.type === 'Success') {
              this.baseService.blockStop();
              this.loading = false;
              if (this.createEditBtn === false) {
                this.loading = false;
                this.alertService.success(this.translate.instant('courseSucss'));
              }
              else if (this.createEditBtn === true) {
                this.loading = false;
                this.alertService.success(this.translate.instant('courseModifed'));
              }
              this.router.navigate(['/teacher-courses/edit', this.teacherId]);
            }
            else {
              this.loading = false;
              this.baseService.blockStop();
              this.alertService.error(this.translate.instant('errorInCreatingCourse'));
            }
          }
        )
      }
    }

    else if (this.courseType === 'pricedCourse') {
      if (this.course.price === 0) {
        this.alertService.error(this.translate.instant('priceCantBeZero'))
      }
      else if (this.course.offerPrice === 0) {
        this.alertService.error(this.translate.instant('offerCantBeZero'))
      }
      else if (this.course.studentsNo === 0) {
        this.alertService.error(this.translate.instant('studentsCantBeZero'))
      }
      else if (this.course.duration === 0) {
        this.alertService.error(this.translate.instant('hoursCantBeZero'))
      }
      else if (this.course.lessons === 0) {
        this.alertService.error(this.translate.instant('lessonsCantBeZero'))
      }
      else {
        this.course.academyToken = this.academyToken;
        this.course.teacherId = this.teacherId;
        this.baseService.blockStart();
        this.courseService.save(this.course).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
          (data: any) => {
            if (data.result.message.type === 'Success') {
              this.baseService.blockStop();
              this.alertService.success(this.translate.instant('courseSucss'));
              this.router.navigate(['/teacher-courses/edit', this.teacherId]);
            }
            else {
              this.baseService.blockStop();
              this.alertService.error(this.translate.instant(''));
            }
          }
        )
      }
    }
  }


  viewCourses(id) {
    this.router.navigate(['/teacher-courses/edit', this.teacherId]);
  }


}
